import React, { createContext, useState, useContext, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => Cookies.get('staff_token'));
  const [username, setUsername] = useState(() => Cookies.get('staff_username'));

  const login = (newToken, newUsername) => {
    Cookies.set('staff_token', newToken, { expires: 1/12 }); // 2 hours
    Cookies.set('staff_username', newUsername, { expires: 1/12 });
    setToken(newToken);
    setUsername(newUsername);
  };

  const logout = () => {
    Cookies.remove('staff_token');
    Cookies.remove('staff_username');
    setToken(null);
    setUsername(null);
  };

  const isAuthenticated = !!token;

  return (
    <AuthContext.Provider value={{ token, username, login, logout, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};